            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">      
                <b-form  inline style="margin-bottom:15px" novalidate> 
                  <b-row style="width:100%;margin-bottom:20px"  v-if="dataForm[namePath].info_aportes.id_list_forma!==1">                      
                    <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_datos_razon"
                          inline
                          :md="5" :lg="5">
                        </sw-inputs>                     
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_list_forma"
                          inline                          
                          modalVariant="secondary"
                          modalTitle="Agregar forma de pago"
                          modalSize="sm"
                          :md="4" :lg="4">
                          <template v-slot:modal="modalInput">
                            <sw-modallistforma 
                              @cerrar="modalInput.modalInput.value=false">
                            </sw-modallistforma>
                          </template>
                        </sw-inputs>                          
                        <sw-inputs
                          style="margin-top: 5px;"
                          inputTabla="info_aportes"
                          inputCampo="label_consecutivo"
                          :showLabel="false"
                          inline
                          :md="4" :lg="4">
                        </sw-inputs>                     
                       
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="descripcion"
                          inline
                          :md="8" :lg="8">
                        </sw-inputs>
                         <sw-inputs
                          v-if="user.admin===1"
                          style="margin-top: 5px;"
                          inputTabla="info_aportes"
                          inputCampo="fecha"
                          :showLabel="false"
                          inline
                          :md="3" :lg="3">
                        </sw-inputs> 
                        <b-col v-else :md="3" :lg="3" style="padding-top: 10px;">
                         {{fecha().fecha.minHoy}}
                        </b-col> 
                  </b-row>  
                  <b-row style="width:100%;margin-bottom:20px" v-if="dataForm[namePath].info_aportes.id_list_forma===1">                      
                    <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_datos_razon"
                          inline
                          :md="5" :lg="5">
                        </sw-inputs>                     
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_list_forma"
                          inline
                          modalVariant="secondary"
                          modalTitle="Agregar forma de pago"
                          modalSize="sm"
                          :md="4" :lg="4">
                          <template v-slot:modal="modalInput">
                            <sw-modallistforma 
                              @cerrar="modalInput.modalInput.value=false">
                            </sw-modallistforma>
                          </template>
                        </sw-inputs>                           
                        <sw-inputs
                          style="margin-top: 5px;"
                          inputTabla="info_aportes"
                          inputCampo="label_consecutivo"
                          :showLabel="false"
                          inline
                          :md="3" :lg="3">
                        </sw-inputs>        
                        <b-col :md="5" :lg="5">
                        </b-col>                                          
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="id_list_cuentas"
                          inline
                          modalVariant="secondary"
                          modalTitle="Agregar cuenta"
                          modalSize="sm"
                          :md="4" :lg="4">
                          <template v-slot:modal="modalInput">
                            <sw-modallistcuentas
                              @cerrar="modalInput.modalInput.value=false">
                            </sw-modallistcuentas>
                          </template>
                        </sw-inputs>   
                        <b-col :md="3" :lg="3">
                        </b-col>   
                        <b-col :md="5" :lg="5">
                        </b-col>     
                        <sw-inputs
                          style="margin-bottom:10px"
                          inputTabla="info_aportes"
                          inputCampo="consignacion"
                          inline
                          :md="4" :lg="4">
                        </sw-inputs>                
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="descripcion"
                          inline
                          :md="8" :lg="8">
                        </sw-inputs>                           
                         <sw-inputs
                          v-if="user.admin===1"
                          style="margin-top: 5px;"
                          inputTabla="info_aportes"
                          inputCampo="fecha"
                          :showLabel="false"
                          inline
                          :md="3" :lg="3">
                        </sw-inputs> 
                        <b-col v-else :md="3" :lg="3"  style="padding-top: 10px;">
                         {{fecha().fecha.minHoy}}
                        </b-col>  
                  </b-row>
                  <b-row style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0">
                    <b-col md="6">
                        <span style="font-weight: 500;display:inline-block;width:80px">Contacto:</span> {{dataForm[namePath].info_aportes.name}}<br>
                        <span style="font-weight: 500;display:inline-block;width:80px">Dirección:</span> {{dataForm[namePath].info_aportes.direccion}} <br>
                        <span style="font-weight: 500;display:inline-block;width:80px">Teléfonos:</span> {{dataForm[namePath].info_aportes.telefonos}}<br>
                    </b-col>  
                    <b-col md="6">
                        <span style="font-weight: 500;display:inline-block;width:100px">Documento:</span> {{dataForm[namePath].info_aportes.documento}} <br>     
                        <span style="font-weight: 500;display:inline-block;width:100px">Correo:</span> {{dataForm[namePath].info_aportes.email}} <br>                      
                        <span style="font-weight: 500;display:inline-block;width:100px"> Asesor:</span>  Oficina<br>                        
                     </b-col> 
                  </b-row>  
                  <b-row style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0; margin-top:10px">
                    <b-col md="6" style="text-align:justify">
                        <span style="font-weight: 500;display:inline-block;width:80px; ">Concepto:</span> {{dataForm[namePath].info_aportes.descripcion}} {{serviciosDescripcion}}
                    </b-col>  
                    <b-col :md="3">
                        <span style="font-weight: 500;display:inline-block;width:100px">Valor:</span> <span style="float:right">{{dataForm[namePath].info_aportes.valor}}</span>
                    </b-col>      
                    <b-col :md="3">
                        <b-form-checkbox
                          @input="changeValor0"
                          v-model="valor0"
                          name="checkbox-1"
                          >
                          Valor en 0
                        </b-form-checkbox>
                    </b-col>             
                  </b-row>  
                  <b-row style="width:100%">                                
                    <sw-inputs
                      inputTabla="info_aportes"
                      inputCampo="observacion"
                      :md="12" :lg="12">
                    </sw-inputs>
                  </b-row>    
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            :index="dataIndex[namePath]"
            nameBtn=""
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwModallistforma  from '@/components/modals/list_forma.vue'
import SwModallistcuentas  from '@/components/modals/list_cuentas.vue'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import moment from 'moment'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform,
    SwModallistforma,
    SwModallistcuentas  
  },
  props: {
  },
  data()
  {
    return {
      valor0:false,
      valor: 0,
      reporte: false,
      valorReporte: 0,
      createdCycle: true,
      active: 1,
      infoDescripcion: '',  
      serviciosDescripcion: '',      
      claseriesgo: null,
      ibc: {
        Afp: null,
        Ccf: null,
        Eps: null,
        Riesgo: null,
      },
      tarifa:{ 
        Afp: null,
        Eps: null,
        Riesgo: null,
        Ccf: null,
      },
      cotizacion: { 
        Afp: null,
        Eps: null,
        Riesgo: null,
        Ccf: null,
      },
      codigo: {
        Ccf: null,
        Afp: null,
        Eps: null,
      },
      saveEvent:false,
      totalAportes: 0,
      ultimoDataForm: {}
    }
  },
  async updated()
  {    
    await this.resetDataForm({state: 'info_aportes/descripcion'})
  },
  async created(){
    if(this.namePath==='servicios_aportes')
    {
      if(this.dataIndex[this.namePath]!==false && this.dataIndex[this.namePath]!==10000)
      {
        await this.updateDataForm({state: 'datos_afiliado', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado})
        await this.updateDataForm({state: 'info_afiliacion', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_afiliacion})
      }  
      else 
      {
        this.ultimoDataForm = await this.deepCopy(this.dataForm[this.namePath])
        let serviciosArchivo_plano = ''
        await this.resetDataForm({state: 'info_aportes'})
        await this.updateDataForm({state: 'info_aportes/descripcion', data: 'Aportes en los servicios de '})   
        await this.updateDataForm({state: 'info_aportes/observacion', data: ''})  
        await this.updateDataIndex({ data: 10000})
        let asesorData = this.gettersDatalist('datos_asesor',this.dataForm[this.namePath].info_afiliacion.id_datos_asesor)
        let j=0
        for (let i = 0; i < this.dataForm[this.namePath].servicios_activos.length; i++) {   
          if(this.dataForm[this.namePath].servicios_activos[i].name!='Administración')
          {
            this.serviciosDescripcion = this.serviciosDescripcion+' '+this.dataForm[this.namePath].servicios_activos[i].name 
            this.valor = parseInt(this.dataForm[this.namePath].servicios_activos[i].valor)+parseInt(this.valor) 
          }         
        }  
        this.serviciosDescripcion = this.serviciosDescripcion+' del mes de '+this.gettersDatalist('list_mes',this.openModal.modal.data.mes_periodo)[0].name+' del '+this.gettersDatalist('list_ano',this.openModal.modal.data.ano_periodo)[0].name  
        const await19 = this.updateDataForm({state: 'info_aportes/valor', data: this.valor})   
        const await20 = this.updateDataForm({state: 'info_aportes/comision', data: 0})    
        const await21 = this.updateDataForm({state: 'info_aportes/servicios', data: 1})      
        const await22 = this.updateDataForm({state: 'info_aportes/id_datos_razon', data: this.dataForm[this.namePath].info_afiliacion.id_datos_razon})
        const await23 = this.updateDataForm({state: 'info_aportes/consecutivo', data: 1552})
        const await24 = this.updateDataForm({state: 'info_aportes/id_datos_asesor', data: this.dataForm[this.namePath].info_afiliacion.id_datos_asesor})
        const await25 = this.updateDataForm({state: 'info_aportes/name', data: this.dataForm[this.namePath].datos_afiliado.name})
        const await26 = this.updateDataForm({state: 'info_aportes/documento', data:  this.dataForm[this.namePath].datos_afiliado.documento})
        const await27 = this.updateDataForm({state: 'info_aportes/direccion', data:  this.dataForm[this.namePath].datos_afiliado.direccion})
        const await28 = this.updateDataForm({state: 'info_aportes/telefonos', data:  this.dataForm[this.namePath].datos_afiliado.telefonos})
        const await29 = this.updateDataForm({state: 'info_aportes/email', data:  this.dataForm[this.namePath].datos_afiliado.email})
        const await30 = this.updateDataForm({state:'info_aportes/fecha', data: this.fecha().fecha.minHoy})
        const await31 = this.updateDataForm({state: 'info_aportes/id_list_mes', data:  parseInt(this.dataForm[this.namePath].info_afiliacion.mes_periodo)})
        const await32 = this.updateDataForm({state: 'info_aportes/id_list_ano', data:  parseInt(this.dataForm[this.namePath].info_afiliacion.ano_periodo)})
            await Promise.all([await19,await20,await21,await22,await23,await24,await25,await26,await27,await28,await29,await30,await31,await32])
        
        
     } 
    } 
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  destroyed()
  {
    this.updateDataForm({data: this.ultimoDataForm})
    this.resetDataIndex()
  },
  computed: { 
  },
  methods: {
    async changeValor0()
    {
      if(this.valor0===true)
      { 
        await this.updateDataForm({state: 'info_aportes/valor', data: 0})
        await this.updateDataForm({state: 'info_aportes/comision', data: 0})
        this.reporte=false 
        return true
      }
      if(this.reporte===false)
      {
        await this.updateDataForm({state: 'info_aportes/valor', data: this.valor})
        await this.updateDataForm({state: 'info_aportes/comision', data: 0})
      }
      return true
    },
    async save(event)
    {
      try { 
        if(this.saveEvent)
        {
          let info_aportes=this.deepCopy(this.dataForm[this.namePath].info_aportes)
          await this.updateDataForm({data: this.ultimoDataForm})
          await this.updateDataForm({state: 'info_aportes', data: info_aportes})
          this.saveEvent=false      
        }
        if(this.saveEvent===false)
        {  
          this.saveEvent=true        
          this.updateDataForm({state: 'aportes_registro/servicios', data: this.dataForm[this.namePath].servicios_activos})
          this.updateDataForm({state: 'info_aportes/descripcion', data: 'Aportes en los servicios de '+this.serviciosDescripcion})  
          
          let mesPeriodo
          let anoPeriodo
          let mes_periodo
          let ano_periodo

          if(this.dataForm[this.namePath].info_afiliacion.servicios===1)
          {
            mesPeriodo=parseInt(this.dataForm[this.namePath].info_aportes.id_list_mes)
            anoPeriodo=parseInt(this.dataForm[this.namePath].info_aportes.id_list_ano)
            mes_periodo=parseInt(this.dataForm[this.namePath].info_aportes.id_list_mes)+1
            ano_periodo=parseInt(this.dataForm[this.namePath].info_aportes.id_list_ano)
          }
          else 
          {            
            mesPeriodo=parseInt(this.openModal.modal.data.mes_periodo)
            anoPeriodo=parseInt(this.openModal.modal.data.ano_periodo)
            mes_periodo=parseInt(this.openModal.modal.data.mes_periodo)+1
            ano_periodo=parseInt(this.openModal.modal.data.ano_periodo)
          }

          let diasAportes=30
          let novedadAportes=2          

          if(mes_periodo===13)
          {
            mes_periodo=1
            ano_periodo=ano_periodo+1
          }
          // actualizar predeterminado de descripcion
          if(this.dataForm[this.namePath].info_aportes.id_list_forma===2 || this.dataForm[this.namePath].info_aportes.id_list_forma===5)
          {
            await this.updateDataForm({state: 'info_aportes/fecha', data: null})
          }
          else 
          {
            for (let k = 0; k < this.dataForm[this.namePath].servicios_activos.length; k++) {
              if(this.dataForm[this.namePath].servicios_activos[k].name!=='Administración')
              {                  
                this.dataForm[this.namePath].servicios_activos[k].mes_periodo=mes_periodo
                this.dataForm[this.namePath].servicios_activos[k].ano_periodo=ano_periodo 
              }                 
            }
            if(this.dataForm[this.namePath].info_afiliacion.servicios===1)
            {
              this.dataForm[this.namePath].info_afiliacion.mes_periodo=mes_periodo
              this.dataForm[this.namePath].info_afiliacion.ano_periodo=ano_periodo 
            }                   
          }  
         
          const await39 = this.updateDataForm({ state: 'info_afiliacion', data: this.dataForm[this.namePath].info_afiliacion})          
          const await41 = this.updateDataForm({state: 'aportes_registro/valor', data: this.dataForm[this.namePath].info_aportes.valor})
          const await42 = this.updateDataForm({state: 'aportes_registro/fecha', data: this.dataForm[this.namePath].info_aportes.fecha}) 
          const await47 =  this.updateDataForm({state: 'aportes_registro/mes_periodo', data: mesPeriodo})
          const await48 =  this.updateDataForm({state: 'aportes_registro/ano_periodo', data: anoPeriodo})
          const await49 =  this.updateDataForm({state: 'aportes_registro/id_list_novedad', data: 2})
          const await50 =  this.updateDataForm({state: 'aportes_registro/servicio', data: 1})

          await Promise.all([await39,await41,await42,await47,await48,await49,await50])         


          this.$emit('save',{save:event.save, ftn: 'aportesFtn' })
        }
      }
      catch(e)
      {
        console.log('error in save aportes aportes registro',e)
      }
    }
  }
}
</script>
<style>
.tabs-sw{
    padding-left: 10px;
    width: 100%;
    padding-top: 12px;
    border-radius: 3px 3px 0 0;
    border: 1px solid #dee2e6;
    background-color: rgba(0,0,0,.03);
}
.tabs-sw .nav-link.active{
  background:white;
} 
</style>